import React from 'react';
import { Helmet } from 'react-helmet-async';

import { getEnvironment } from '~lib/frontend/helpers/environment';
import { createAwareUrl } from '~lib/frontend/helpers/uri';
import HeaderHero from '~website/components/Hero/HeaderHero';
import Footer from '~website/components/layout/footer';

const TooManyRequests: React.FunctionComponent = () => {
	const environment = getEnvironment();
	const url = environment === 'server' ? '/' : createAwareUrl('/');

	return (
		<React.Fragment>
			<Helmet defer>
				<title>{'Offer not found | Cuvva'}</title>
				<meta name={'robots'} content={'noindex, follow'} />
			</Helmet>
			<HeaderHero
				titleSegment={{
					centered: true,
					title: 'Too many requests',
					body: 'Please wait a while, then try again',
					showButton: {
						text: 'Country roads, take me home...',
						url,
					},
				}}
				mainImage={void 0}
			/>
			<Footer />
		</React.Fragment>
	);
};

export default TooManyRequests;
